<template>
  <div
    ref="popup"
    class="ol-overlaycontainer-stopevent ol-popup"
    style="max-width: 500px; background-color: white"
  >
    <div class="content" v-if="infoContent.typedID">
      <div @click="closePopup" style="height: 2.6em">
        <i
          class="fas fa-window-close closer"
          style="font-size: 2.6em; float: right"
        ></i>
      </div>
      <nav class="popup-nav" v-show="flatFeatures.length > 1">
        <ul class="pagination justify-content-center">
          <li class="page-item" :class="{ disabled: selectIndex === 0 }">
            <a
              class="prev page-link"
              href="#"
              @click.prevent="prevItem"
              :aria-disabled="selectIndex === 0"
            >
              <span aria-hidden="true">«</span>
              <span class="sr-only">vorig</span>
            </a>
          </li>
          <li
            style="padding: 6px"
            class="page-item border text-primary align-middle info"
          >
            {{ selectIndex + 1 }} / {{ flatFeatures.length }}
          </li>
          <li
            class="page-item"
            :class="{ disabled: selectIndex === flatFeatures.length - 1 }"
          >
            <a
              class="next page-link"
              href="#"
              @click.prevent="nextItem"
              :aria-disabled="selectIndex === flatFeatures.length - 1"
            >
              <span aria-hidden="true">»</span>
              <span class="sr-only">volgende</span>
            </a>
          </li>
        </ul>
      </nav>

      <div class="container pt-1 pb-1">
        <div class="row">
          <div class="col font-weight-bold">Type:</div>
          <div class="col">{{ typeNames[type] }}</div>
        </div>

        <div class="row">
          <div class="col font-weight-bold">Naam:</div>
          <div class="col">
            <span>{{ infoContent.name }}</span>
            <span v-if="infoContent[type + '_soort']">
              ({{ infoContent[type + "_soort"].name }})</span>
          </div>
        </div>

        <div class="row" v-if="infoContent.firstImage != null">
          <div class="col popupimage">
            <img
              v-show="showimage"
              @load="showimage = true"
              :src="'/image/' + infoContent.firstImage.path"
              class="image-fluid rounded"
            />
          </div>
        </div>

        <div class="row" v-show="infoContent.description_plain">
          <div class="col-12 font-weight-bold mb-2">Omschrijving:</div>

          <div
            class="col-12 showOnlyTwoLines"
            :class="{ marker: isPreviewTextOverflow }"
          >
            <div>
              <p
                ref="textPreviewElem"
                v-text="infoContent.description_plain"
              ></p>
            </div>
          </div>
        </div>
        <div
          class="row"
          v-if="isPreviewTextOverflow && infoContent.description_plain"
        >
          <div class="col-12 mb-2">
            <a class :href="'/detail/monument/' + infoContent.typedID"
              >Lees verder</a
            >
          </div>
        </div>
        <div
          class="row"
          v-if="infoContent.links && infoContent.links.length > 0"
        >
          <div class="col font-weight-bold">Links:</div>
        </div>
        <div class="row" v-for="item in infoContent.links" :key="item.id">
          <div class="col">
            <a :href="item.url" target="_blank">{{ item.label }}</a>
          </div>
        </div>

        <div class="row" v-show="'ls' === this.type && infoContent.rating">
          <div class="col font-weight-bold">Waardering:</div>
          <div class="col">{{ infoContent.rating }}</div>
        </div>

        <div class="row" v-show="'ls' === this.type && !infoContent.peildatum">
          <div class="col font-weight-bold">Peildatum:</div>
          <div class="col">Onbekend</div>
        </div>

        <div class="row" v-if="infoContent.peildatum">
          <div class="col font-weight-bold">Peildatum:</div>
          <div class="col">{{ infoContent.peildatum | dateformat }}</div>
        </div>

        <div class="row" v-if="hasAdress">
          <div class="col font-weight-bold">Adres:</div>
          <div class="col">
            <span>{{ infoContent.straatnaam }}</span>
            <span>{{ infoContent.huisnr }}</span>
            <span>{{ infoContent.huisltr }}</span>
            <br />
            <span>{{ infoContent.postcode }}</span>
            <span v-if="infoContent.gem_naam">,</span>
            <span>{{ infoContent.gem_naam }}</span>
          </div>
        </div>

        <div class="row d-none" v-show="isPrivate && infoContent.bouwjaar_bag">
          <div class="col font-weight-bold">Bouwjaar:</div>
          <div class="col">{{ infoContent.bouwjaar_bag }}</div>
        </div>
        <!--
        <div class="row d-none" v-show="isPrivate">
          <div class="col font-weight-bold">Samengesteld object:</div>
          <div class="col"></div>
        </div>
        -->
        <div class="row" v-show="isPrivate && infoContent.id_vbosl">
          <div class="col font-weight-bold">BAG verblijfsobject ID:</div>
          <div class="col">{{ infoContent.id_vbosl }}</div>
        </div>
        <div class="row" v-show="isPrivate && infoContent.id_pand">
          <div class="col font-weight-bold">BAG pand ID:</div>
          <div class="col">{{ infoContent.id_pand }}</div>
        </div>

        <div class="row" v-show="isPrivate && infoContent.id_perceel">
          <div class="col font-weight-bold">BRK perceel ID:</div>
          <div class="col">{{ infoContent.id_perceel }}</div>
        </div>

        <div class="row" v-show="isPrivate && infoContent.buurt_code">
          <div class="col font-weight-bold">Buurt code:</div>
          <div class="col">{{ infoContent.buurt_code }}</div>
        </div>

        <div class="row" v-show="infoContent.buurt_naam">
          <div class="col font-weight-bold">Buurt naam:</div>
          <div class="col">{{ infoContent.buurt_naam }}</div>
        </div>

        <div class="row" v-show="isPrivate && infoContent.wijk_code">
          <div class="col font-weight-bold">Wijk code:</div>
          <div class="col">{{ infoContent.wijk_code }}</div>
        </div>

        <div class="row" v-show="infoContent.wijk_naam">
          <div class="col font-weight-bold">Wijk naam:</div>
          <div class="col">{{ infoContent.wijk_naam }}</div>
        </div>

        <div class="row" v-show="isPrivate && infoContent.gem_code">
          <div class="col font-weight-bold">Gemeente code:</div>
          <div class="col">{{ infoContent.gem_code }}</div>
        </div>

        <div class="row" v-show="infoContent.gem_naam">
          <div class="col font-weight-bold">Gemeentenaam:</div>
          <div class="col">{{ infoContent.gem_naam }}</div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <a
              class="btn btn-primary"
              target="_blank"
              :href="
                '/print/monument/' + infoContent.typedID + '?hideCode=false'
              "
              role="button"
              >Afdruk</a
            >
          </div>
          <div class="col" v-if="isPrivate && isEditable">
            <a
              class="btn btn-primary"
              :href="'/beheer/monument/' + infoContent.typedID"
              role="button"
              >Bewerken</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Overlay from "ol/Overlay";
import axios from "axios";
import moment from "moment";
import paramsUtils from "../paramsUtils";
import {layerSourcePromise} from "../openlayers/overlayLayers";

/**
 * Create an overlay to anchor the popup to the map.
 */
var popup = new Overlay({
  autoPan: true,
  autoPanAnimation: {
    duration: 250,
  },
});

//test
const checkSelectedID = function () {
  let selectedIDParam = paramsUtils.parseHashBangArgs()["id"];
  const numberRegexp = /\d+/g;
  if (selectedIDParam) {
    if (selectedIDParam.startsWith("LS_ext_")) {
      return selectedIDParam;
    } else {
      selectedIDParam = selectedIDParam.toLowerCase();
      var match = selectedIDParam.match(numberRegexp);
      if (match && match.length) {
        if (match.length == 1) {
          selectedIDParam = selectedIDParam.substring(0, 2) + "_" + match[0];
        } else {
          selectedIDParam = selectedIDParam.substring(0, 2) + "_" + match[1];
        }
      }
    }

    return selectedIDParam;
  }
  return null;
};
const checkSelectedFeatureFromHash = function (map) {
  const id = checkSelectedID();

  if (id) {
    const vectorLayer = map.get("vectorLayer");
    const vectorLayerBig = map.get("vectorLayerBig");
    const layer_ls = map.get("layer_ls");

    if (vectorLayer) {
      const selectedFeature = vectorLayer.getSource().getFeatureById(id);
      if (selectedFeature) {
        return selectedFeature;
      }
    }
    if (vectorLayerBig) {
      const selectedFeature = vectorLayerBig.getSource().getFeatureById(id);
      if (selectedFeature) {
        return selectedFeature;
      }
    }
    if (layer_ls) {
      const selectedFeature = layer_ls.getSource().getFeatureById(id);
      if (selectedFeature) {
        return selectedFeature;
      }
    }
  }
  return null;
};

//end test

export default {
  props: ["features", "selectedID", "map", "coordinate", "isPrivate"],
  data() {
    return {
      isPreviewTextOverflow: false,
      showimage: false,
      typeNames: {
        gm: "Gemeentelijk (GM)",
        rm: "Rijksmonument (RM)",
        kp: "Karakteristieke panden (KP)",
        bg: "Beschermde stads- en dorpsgezichten (BG)",
        rg: "Rijks beschermde stads- en dorpsgezichten (RG)",
        ls: "Landschapsstructuren (LS)",
      },
      type: "",
      infoContent: {},
      id: "",
      clusterFeatureIndexOffset: 0,
      selectIndex: 0,
      flatFeatures: [],
    };
  },
  created() {},
  mounted() {
    popup.setElement(this.$refs.popup);
    if (this.map != null) {
      this.map.addOverlay(popup);
      layerSourcePromise.then((vsource) => {
        setTimeout(() => {
          const selectedFeature = checkSelectedFeatureFromHash(this.map);
          if (selectedFeature) {
            this.flatFeatures = [];
            this.selectIndex = 0;
            this.clusterFeatureIndexOffset = 0;
            this.calculateCurrentIndex([selectedFeature]);
            this.fetchInfo(this.flatFeatures[this.selectIndex].getId());
          }
        }, 1000);
      });
    }
  },
  beforeDestroy() {
    if (this.map !== null) {
      this.map.removeOverlay(popup);
    }

    popup.setElement(null);
  },
  filters: {
    dateformat: function (value) {
      if (!value) return "";
      return moment(value, "x").format("DD-MM-YYYY");
    },
  },
  methods: {
    isPreviewTextOverflowCheck() {
      const textPreviewElem = this.$refs.textPreviewElem;

      return (
        textPreviewElem &&
        textPreviewElem.clientHeight >
          textPreviewElem.parentElement.clientHeight
      );
    },
    calculateCurrentIndex(features) {
      let clusterFeature = null;
      features.forEach((selectedFeature, index) => {
        const clusteredFeatures = selectedFeature.get("features");
        if (clusteredFeatures) {
          this.calculateCurrentIndex(clusteredFeatures);
          clusterFeature = selectedFeature;
          this.clusterFeatureIndexOffset = index;
        } else {
          this.flatFeatures.push(selectedFeature);

          if (this.selectedID && selectedFeature.getId() === this.selectedID) {
            this.selectIndex = index;
            if (clusterFeature) {
              clusterFeature.set(
                "selectIndex",
                this.selectIndex - this.clusterFeatureIndexOffset
              );
            }
          }
        }
      });
    },
    calculateCoordinateAndShow() {
      let nearestCoordinate;

      if (this.coordinate.length === 0) {
        nearestCoordinate = this.flatFeatures[this.selectIndex]
          .getGeometry()
          .getFirstCoordinate();
      } else {
        if (
          this.flatFeatures[this.selectIndex]
            .getGeometry()
            .intersectsCoordinate(this.coordinate)
        ) {
          nearestCoordinate = this.coordinate;
        } else {
          nearestCoordinate = this.flatFeatures[this.selectIndex]
            .getGeometry()
            .getClosestPoint(this.coordinate);
        }
      }
      this.map.getTarget().classList.add("showinfo");
      popup.setPosition(nearestCoordinate);
      this.isPreviewTextOverflow = this.isPreviewTextOverflowCheck();
    },
    prevItem() {
      this.showimage = false;
      this.selectIndex = Math.max(0, this.selectIndex - 1);
      this.fetchInfo(this.flatFeatures[this.selectIndex].getId());
    },
    nextItem() {
      this.showimage = false;
      this.selectIndex = Math.min(
        this.flatFeatures.length - 1,
        this.selectIndex + 1
      );
      this.fetchInfo(this.flatFeatures[this.selectIndex].getId());
    },
    closePopup() {
      //this.showimage = true;
      popup.setPosition();
      this.map.getTarget().classList.remove("showinfo");
      this.infoContent = {};
      this.id = "";
      this.clusterFeatureIndexOffset = 0;
      this.selectIndex = 0;
      this.flatFeatures = [];
      this.$emit("close");
    },

    async fetchInfo(id) {
      const detail_url =
        "/monument/" + (this.isPublic ? "public/" : "") + "detail/";
      const response = await axios(detail_url + id);
      this.infoContent = response.data;
      this.type = this.infoContent.typedID.substring(0, 2);
      this.$nextTick(() => {
        this.calculateCoordinateAndShow();
      });
    },
    close() {},
  },
  computed: {
    isEditable() {
      return "ls" !== this.type;
    },
    isPublic() {
      return this.$store.state.isPublicPage;
    },

    hasAdress() {
      return (
        this.infoContent &&
        (this.infoContent.straatnaam ||
          this.infoContent.huisnr ||
          this.infoContent.huisltr ||
          this.infoContent.postcode)
      );
    },
  },
  watch: {
    features: function (val) {
      this.showimage = false;
      if (val.length === 0) {
        this.closePopup();
      } else {
        this.flatFeatures = [];
        this.selectIndex = 0;
        this.clusterFeatureIndexOffset = 0;
        this.calculateCurrentIndex(val);
        this.fetchInfo(this.flatFeatures[this.selectIndex].getId());
      }
    },
    map(newValue, oldValue) {
      if (newValue !== null) {
        newValue.addOverlay(popup);
        layerSourcePromise.then((vsource) => {
          setTimeout(() => {
            const selectedFeature = checkSelectedFeatureFromHash(newValue);
            if (selectedFeature) {
              this.flatFeatures = [];
              this.selectIndex = 0;
              this.clusterFeatureIndexOffset = 0;
              this.calculateCurrentIndex([selectedFeature]);
              this.fetchInfo(this.flatFeatures[this.selectIndex].getId());
            }
          }, 1000);
        });
      } else if (oldValue != null) {
        oldValue.removeOverlay(popup);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.ol-popup {
  position: absolute;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  min-width: 280px;
}
.ol-popup:after,
.ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}
.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}
.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
}
.ol-popup-closer:after {
  content: "✖";
}

/*And then change */
.popupimage {
  height: 250px;

  .image-fluid {
    display: block;
    width: auto;
    max-height: 100%;
    max-width: 100%;
  }
}
.showOnlyTwoLines > div {
  line-height: 1.5em;
  height: 3em;
  overflow: hidden;
}
.showOnlyTwoLines.marker:after {
  content: "...";
}
</style>